<p-icon class="attachment-icon" [name]="icon()" size="sm" color="functional-default"></p-icon>
@if (leadingDetail()) {
<span class="attachment-detail">{{ leadingDetail() }}</span>
}
<span class="attachment-label">{{ shownLabel() }}</span>
@if (trailingDetail()) {
<span class="attachment-detail">{{ trailingDetail() }}</span>
} @if (showRemoveButton()) {
<p-button
    class="attachment-remove"
    automation-id="p-attachment-preview-remove"
    [ariaLabel]="removeLabel()"
    [buttonType]="buttonType.IsIcon"
    iconBefore="x"
    iconBeforeSize="xs"
    (buttonClicked)="onRemoveClicked()"
>
</p-button>
}
